import React from "react";
import connection from "../../connection";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import pagamentosStyle from "assets/jss/material-dashboard-pro-react/views/pagamentosStyle.jsx";
import CardBody from "../../components/Card/CardBody";
import ListaPagamentos from "../../components/ListaPagamentos/ListaPagamentos";
import {SlideDown} from "react-slidedown";
import ExtratoPortaMoedas from "../../components/ExtratoPortaMoedas";
import EstadoUtilizador from "../../components/EstadoUtilizador";
import ReactTable from "../../components/ReactTableWrapper";


class Pagamentos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pagamentos_pendentes: [],
      pagamentos_outros: [],
      credito_porta_moedas: []
    };

    this.loadPagamentos = async () => {
      let pagamentos = await connection.get("pagamentos/pendentes");
      let pagamentos_pendentes = pagamentos.filter(pagamento => pagamento.estado_pagamento === "pendente" || (pagamento.estado_pagamento === "faltou" && new Date(pagamento.data_limite_pagamento) >= new Date()) || (pagamento.estado_pagamento === "referencia_pendente" && !pagamento.dados_pagamento));
      let pagamentos_outros = pagamentos.filter(pagamento => pagamento.estado_pagamento !== "pendente" && !(pagamento.estado_pagamento === "faltou" && new Date(pagamento.data_limite_pagamento) >= new Date()) && !(pagamento.estado_pagamento === "referencia_pendente" && !pagamento.dados_pagamento));
      let credito_porta_moedas = await connection.get("pagamentos/creditos_porta_moedas");

      this.setState({pagamentos_pendentes, pagamentos_outros, credito_porta_moedas});
    }
  }

  componentDidMount() {
    this.loadPagamentos();
  }

  render() {
    const {classes} = this.props;

    return (<div>
      <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardIconTitle}>Pagamentos Pendentes</h4>
        </CardHeader>
        {this.state.pagamentos_pendentes.length > 0 ?
          <ListaPagamentos classes={this.state.classes} pagamentos={this.state.pagamentos_pendentes} atualizar={() => this.loadPagamentos()}/> :
          <CardBody style={{textAlign: "center", padding: "4em 0", color: "#bbbbbb"}}>
            <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Sem pagamentos pendentes</h5>
            <p>Os seu pagamentos pendentes serão apresentados aqui</p>
          </CardBody>}
      </Card>
      <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardIconTitle}>Histórico de pagamentos</h4>
        </CardHeader>
        {this.state.pagamentos_outros.length > 0 ?
          <ListaPagamentos pagamentos={this.state.pagamentos_outros} atualizar={() => this.loadPagamentos()}/> :
          <CardBody style={{textAlign: "center", padding: "4em 0", color: "#bbbbbb"}}>
            <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Sem informações para apresentar</h5>
            <p>Os seu histórico de pagamentos será apresentado aqui</p>
          </CardBody>}
      </Card>
      <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardIconTitle}>Créditos no Porta Moedas</h4>
        </CardHeader>
        {this.state.credito_porta_moedas.length > 0 ? <ReactTable
          data={this.state.credito_porta_moedas}
          minRows={1}
          SubComponent={(row) => <SlideDown className={'my-dropdown-slidedown'}>
            {row.original.extrato && <div className={classes.wrapper}>
              <ExtratoPortaMoedas stories={JSON.parse(row.original.extrato).map((e, i) => {
                return {
                  inverted: false,
                  estado: e.acao,
                  designacao: e.designacao,
                  saldo_inicial: e.saldo_inicial,
                  valor: e.valor,
                  saldo_final: e.saldo_final,
                  data: e.data,
                  descricao: e.descricao
                };
              })}></ExtratoPortaMoedas>
            </div>}
          </SlideDown>}
          columns={[
            {
              Header: "Nome",
              accessor: "nome_curto",
              maxWidth: 1000,
              Cell: (row) => <span>
                    <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                    <span style={{fontSize: 10, display: "block", marginTop: -3, color: "#5e5e5e"}}>{row.original.agrupamento + (row.original.nucleo ? " / " + row.original.nucleo : '') + (row.original.regiao ? " / " + row.original.regiao : '')}</span>
                  </span>
            },
            {
              Header: "Região",
              accessor: "regiao_credito",
              maxWidth: 200
            },
            {
              Header: "Saldo",
              Cell: ({original}) => <span>{original.saldo.toFixed(2) + "€"}</span>,
              sortable: true,
              maxWidth: 100
            }
          ]}
          defaultPageSize={10}
          showPaginationBottom={true}
          className="-striped -highlight"
        /> : <CardBody style={{textAlign: "center", padding: "4em 0", color: "#bbbbbb"}}>
          <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Sem créditos no porta moedas</h5>
          <p>Os seu histórico de créditos será apresentado aqui</p>
        </CardBody>}
      </Card>
    </div>);
  }
}

export default withStyles(pagamentosStyle)(Pagamentos);
